export const fullDate = (d) => {
  if (!d) return;
  // eslint-disable-next-line no-unused-vars
  const [_date] = d.split('T');
  const [year, month, day] = _date.split('-');
  return `${day}.${month}.${year}`;
};
